import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NetworkService } from "../core/service/network.service";
import { Network } from "../core/model/network";
import { EditNetworkComponent } from "./edit-network/edit-network.component";
import { AddNetworkComponent } from "./add-network/add-network.component";

@Component({
  selector: "app-network",
  templateUrl: "./network.component.html",
  styleUrls: ["./network.component.scss"],
})
export class NetworkComponent implements OnInit {
  networks: Network[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _networkService: NetworkService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getNetworks();
  }

  getNetworks() {
    this._networkService.getAllNetworks().subscribe(
      (data) => {
        this.networks = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(network: Network): void {
    const modalRef = this.modalService.open(EditNetworkComponent, {
      centered: true,
    });
    modalRef.componentInstance.network = network;

    modalRef.result.then(
      (updated: Network) => {
        if (updated && this.networks) {
          const index = this.networks.findIndex((n) => n.id === updated.id);
          if (index !== -1) {
            this.networks[index] = updated;
            this.networks = [...this.networks];
            return;
          }
        }
        this.getNetworks();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddNetworkComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getNetworks();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
